module.exports = __webpack_public_path__ + "static/img/blog-8.0f4dbb77.webp";